import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Bitcoin Navigator ships a single model portfolio served by the generic
// wealth-series endpoints (tier=navigator; the backend auto-upgrades to
// navigator_auto for entitled users). Unlike the wealthPortfolio duck, state
// is keyed plainly so it works regardless of the portfolio's UUID.
const INIT_STATE = {
  portfolio: null,
  performanceSummary: null,
  loading: true,
  error: null,
};

// Action Types
export const BITCOIN_NAVIGATOR_LOAD = "BITCOIN_NAVIGATOR/LOAD";
export const BITCOIN_NAVIGATOR_LOAD_SUCCESS = "BITCOIN_NAVIGATOR/LOAD/SUCCESS";
export const BITCOIN_NAVIGATOR_LOAD_FAILURE = "BITCOIN_NAVIGATOR/LOAD/FAILURE";

// Action Creators
export const bitcoinNavigatorLoad = () => ({
  type: BITCOIN_NAVIGATOR_LOAD,
});

export const bitcoinNavigatorLoadSuccess = (portfolio, performanceSummary) => ({
  type: BITCOIN_NAVIGATOR_LOAD_SUCCESS,
  portfolio,
  performanceSummary,
});

export const bitcoinNavigatorLoadFailure = (error) => ({
  type: BITCOIN_NAVIGATOR_LOAD_FAILURE,
  error,
});

// Sagas
function* fetchBitcoinNavigator() {
  try {
    const { data: portfolios } = yield axios.get(
      `${apiURL}/wealth-series/portfolios?tier=navigator`,
      { withCredentials: true },
    );

    const portfolio = Array.isArray(portfolios) ? portfolios[0] : null;
    if (!portfolio?.portfolio_id) {
      yield put(bitcoinNavigatorLoadSuccess(null, null));
      return;
    }

    const [adjustmentsResponse, summaryResponse] = yield Promise.all([
      axios.get(
        `${apiURL}/wealth-series/portfolios/${portfolio.portfolio_id}/adjustments`,
        { withCredentials: true },
      ),
      axios
        .get(
          `${apiURL}/wealth-series/portfolios/${portfolio.portfolio_id}/performance-summary`,
          { withCredentials: true },
        )
        .catch(() => null), // stats degrade gracefully if the summary is missing
    ]);

    yield put(
      bitcoinNavigatorLoadSuccess(
        {
          ...portfolio,
          adjustments: adjustmentsResponse?.data || [],
        },
        summaryResponse?.data || null,
      ),
    );
  } catch (error) {
    yield put(bitcoinNavigatorLoadFailure(error));
  }
}

function* listenBitcoinNavigatorLoad() {
  yield takeEvery(BITCOIN_NAVIGATOR_LOAD, fetchBitcoinNavigator);
}

// Root Saga
export function* saga() {
  yield all([fork(listenBitcoinNavigatorLoad)]);
}

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BITCOIN_NAVIGATOR_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case BITCOIN_NAVIGATOR_LOAD_SUCCESS:
      return {
        ...state,
        portfolio: action.portfolio,
        performanceSummary: action.performanceSummary,
        loading: false,
        error: null,
      };
    case BITCOIN_NAVIGATOR_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default reducer;
